import Reveal from "@/components/base/Reveal";
import { planComparison } from "@/mocks/hospedagem";

export default function PlanComparison() {
  return (
    <section id="comparativo" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
              <i className="ri-layout-grid-line" aria-hidden="true"></i>
              Comparativo
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              Compare os planos lado a lado.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Veja de forma clara o que cada plano oferece para escolher com segurança.
            </p>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 overflow-hidden rounded-xl border border-background-200 bg-background-50">
            <div className="overflow-x-auto nx-scrollbar">
              <table className="w-full min-w-[680px] border-collapse text-left">
                <thead>
                  <tr className="bg-background-100">
                    <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-foreground-500">
                      Recursos
                    </th>
                    {planComparison.plans.map((plan) => (
                      <th
                        key={plan}
                        className="px-5 py-4 text-center font-heading text-sm font-semibold text-foreground-950"
                      >
                        {plan}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {planComparison.rows.map((row, rowIndex) => (
                    <tr
                      key={row.feature}
                      className={rowIndex % 2 === 1 ? "bg-background-100/50" : "bg-background-50"}
                    >
                      <td className="px-5 py-4 text-sm font-medium text-foreground-800">
                        {row.feature}
                      </td>
                      {row.values.map((value, valueIndex) => (
                        <td
                          key={`${row.feature}-${planComparison.plans[valueIndex]}`}
                          className="px-5 py-4 text-center"
                        >
                          {value ? (
                            <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                              <i className="ri-check-line" aria-hidden="true"></i>
                            </span>
                          ) : (
                            <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-background-200 text-foreground-400">
                              <i className="ri-subtract-line" aria-hidden="true"></i>
                            </span>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>

        <Reveal>
          <p className="mt-6 text-center text-xs text-foreground-500">
            Os recursos apresentados são configuráveis e podem ser ajustados conforme a necessidade
            do seu projeto.
          </p>
        </Reveal>
      </div>
    </section>
  );
}